import React, { Fragment } from 'react';
import { LinkV2, styled } from '@withjoy/joykit';
import { useHeaderLinks } from '../../useHeaderLinks';

const StyledLinkV2 = styled(LinkV2)`
  display: none;
`;

export const SeoHeaderLinks: React.FC = () => {
  const { allItemsToRender } = useHeaderLinks();
  return (
    <>
      {allItemsToRender.map((menuLink, index) => (
        <Fragment key={`dom-parent-link-${menuLink.id}-${index}`}>
          <StyledLinkV2
            key={`dom-link-${menuLink.id}-${index}`}
            id={`dom-link-${menuLink.id}`}
            href={menuLink.href}
            typographyVariant="FeatureCopy17"
          >
            {menuLink.label}
          </StyledLinkV2>
          {menuLink.blogs && (
            <>
              {menuLink.blogs.map(blogLink => (
                <Fragment key={`dom-blog-parent-link-${blogLink.id}-${index}`}>
                  <StyledLinkV2
                    key={`dom-blog-link-${blogLink.id}-${index}`}
                    id={`dom-link-${blogLink.id}`}
                    href={blogLink.href}
                    typographyVariant="FeatureCopy17"
                  >
                    {blogLink.label}
                  </StyledLinkV2>
                </Fragment>
              ))}
            </>
          )}
        </Fragment>
      ))}
    </>
  );
};
